import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Gallery from "../components/gallery/gallery"
import Companys from "../components/companys"
import liva from "../assets/img/liva-basari.webp"
import stm from "../assets/img/stm-digital-pazarlama.webp"
import { Link } from "gatsby"

const Referances = () => (
  <Layout>
    <SEO
      title="Brands | Flatart"
      description="Check out statistics from our previous clients. These reflect our services and special strategies."
    />
    <div className="refrances container">
      <div className="referances-head">
        <h1>Real success stories.</h1>
        <p>
          Check out statistics from our previous clients. These reflect our
          services and special strategies.
        </p>
      </div>

      <div className="row referances-markalar py60">
        <div className="item col-md-6">
          <Link to="/success-stories/liva-pastacilik/">
            <img src={liva} alt="Liva Pastacılık" />
          </Link>
          <p className="small">Digital Marketing</p>
          <Link to="/success-stories/liva-pastacilik/">Liva Pastacılık</Link>
          <p>
            Liva Pastry, which has been serving in Ankara with its 4 branches since 1993,
            has achieved rising success over the years with its digital transformation.
          </p>
          <div className="item-bottom">
            <p className="bold">+90k</p>
            <p className="small">Monthly organic traffic acquired</p>
          </div>
          <div className="item-bottom">
            <p className="bold">4,500</p>
            <p className="small">Monthly orders and counting</p>
          </div>
        </div>
        <div className="item col-md-6">
          <Link to="/success-stories/stm/">
            <img src={stm} alt="STM" />
          </Link>
          <p className="small">Digital Marketing</p>
          <Link to="/success-stories/stm/">STM</Link>
          <p>
            Flatart provides 360° digital marketing services to the STM brand to
            powerfully convey its brand awareness.
          </p>
          <div className="item-bottom">
            <p className="bold">+22%</p>
            <p className="small">Organic Traffic Increase</p>
          </div>
          <div className="item-bottom">
            <p className="bold">+27.7%</p>
            <p className="small">Follower Acquisition</p>
          </div>
        </div>
      </div>

      <div className="hero" style={{ marginTop: -30, marginBottom: 50 }}>
        <Link to="/success-stories/">
          <button className="red-button">View All Success Stories</button>
        </Link>
      </div>
    </div>

    <div className="our-clients container">
      <h2>Our Clients</h2>
      <Companys />
    </div>

    <div className="py60">
      <Gallery name="all" />
    </div>
  </Layout>
)

export default Referances
